import { For } from "solid-js";
import { cn } from "@folio/shared";

/**
 * Suggested emoji set for a note page icon.
 * (The original template took `LIST_ICONS` from the template's domain, since removed.)
 */
const PAGE_ICONS = [
  "📄",
  "📝",
  "📒",
  "📓",
  "📔",
  "📚",
  "📖",
  "🗂️",
  "📌",
  "📎",
  "✏️",
  "🖊️",
  "💡",
  "⭐",
  "🔖",
  "🏷️",
  "✅",
  "🎯",
  "🚀",
  "🔥",
  "❤️",
  "🌱",
  "🧠",
  "🗒️",
] as const;

interface IconPickerProps {
  selectedIcon: string;
  onSelect: (icon: string) => void;
}

export function IconPicker(props: IconPickerProps) {
  return (
    <div class="flex flex-wrap gap-2">
      <For each={PAGE_ICONS}>
        {(icon) => (
          <button
            type="button"
            onClick={() => {
              props.onSelect(icon);
            }}
            class={cn(
              "flex h-10 w-10 items-center justify-center rounded-xl border-2 transition-[background-color,border-color,transform] motion-safe:will-change-transform hover:bg-accent/10 active:scale-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
              props.selectedIcon === icon ? "border-primary bg-primary/5" : "border-border/50",
            )}
          >
            <span class="text-xl">{icon}</span>
          </button>
        )}
      </For>
    </div>
  );
}
